import { useMemo } from 'react'
import { LocalStorageKeys } from 'utils/local-storage'
import { useLocalStorage } from './use-local-storage'

export const useSignedPricings = () => {
  const signedIds = useLocalStorage<string[]>(
    LocalStorageKeys.SignedPricings,
    []
  )
  return useMemo(() => ({ signedIds: new Set(signedIds) }), [signedIds])
}
